module.exports = __webpack_public_path__ + "static/media/orders.a6504c0f.svg";